export default [
    {
        path: '/dynamic-offer',
        name: 'dynamic-offer',
        component: () => import ('./pages/Index'),
        meta: {
            title: 'Oferta',
            icon: 'mdi-puzzle-outline',
            breadcrumbs: [
                { text: 'Oferta dinâmica', disabled: true, href: '/' },
                { text: 'Oferta', disabled: true, href: '/' },
            ],
        }
    },
]